import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@hub/ui/components/ui/select";

interface TeamSelectorProps {
  teams: string[];
  value: string;
  onChange: (team: string) => void;
}

export function TeamSelector({ teams, value, onChange }: TeamSelectorProps) {
  if (teams.length <= 1) return null;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[180px] h-8 text-xs">
        <SelectValue placeholder="Select team" />
      </SelectTrigger>
      <SelectContent>
        {teams.map((team) => (
          <SelectItem key={team} value={team}>
            {team}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
